import { render, staticRenderFns } from "./scanDownload.vue?vue&type=template&id=38be9f66&scoped=true"
import script from "./scanDownload.vue?vue&type=script&lang=ts"
export * from "./scanDownload.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./scanDownload.vue?vue&type=style&index=0&id=38be9f66&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "38be9f66",
  "1a2c2806"
  
)

export default component.exports